import { SOURCE_STATUS_COLOR_MAPPING } from '_/constants/common';
import { Tag } from 'antd';
import React, { ReactElement } from 'react';

export const setSourceStatusTag = (status: string): ReactElement => {
  return <Tag color={SOURCE_STATUS_COLOR_MAPPING[status]}>{status}</Tag>;
};
